import { createApi } from '@reduxjs/toolkit/query/react';
import config from '../../config/config';
import axiosBaseQuery from './axiosBaseQuery/axiosBaseQuery';

// Define a service using a base URL and expected endpoints
export const apDropdownAPI = createApi({
  reducerPath: 'apDropdownAPI',
  baseQuery: axiosBaseQuery({
    baseUrl: config?.appUrl,
  }),
  keepUnusedDataFor: 900,
  endpoints: (builder) => ({
    getAPDropdownList: builder.query<any, void>({
      query: () => ({
        url: `/am/myap`,
        method: 'GET',
      }),
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetAPDropdownListQuery } = apDropdownAPI;
